import PropTypes from 'prop-types'

import style from '@aytm/app/stats/page/comments/comments/styles/OEItem.module.scss'

const ImageResponse = ({ node }) => {
  const { url, width, height } = node.i.original

  return (
    <div className={style['comment-answer-image']}>
      <img id={`commments-image-${node.i.uid}`} src={url} width={width} height={height} alt="Image answer" />
    </div>
  )
}

ImageResponse.propTypes = {
  node: PropTypes.object
}

ImageResponse.displayName = 'ImageResponse'

export default ImageResponse
